export default __webpack_public_path__ + "static/design-components-02f32e4a48b646018bb3874fdf868292.png";